import Axios from 'axios';
import favoriteStore from '../stores';
import { toast } from 'react-toastify';

function updateFavoritesButton(productId) {
    const tweakwiseVehicleCard = document.querySelector('#twn-' + productId);

    if (tweakwiseVehicleCard) {
        const favoritesButton = tweakwiseVehicleCard.querySelector('.twn-product-tile__favorites-button');

        if (favoritesButton) {
            if (favoritesButton.classList.contains('is-added')) {
                favoritesButton.classList.remove('is-added');
            } else {
                favoritesButton.classList.add('is-added');
            }
        }
    }
}

document.addEventListener('favorites-updated', function (event) {
    const updateUrl = event.detail.updateUrl;
    const productId = event.detail.productId;

    updateFavoritesButton(productId);

    if (updateUrl) {
        Axios.get(updateUrl)
            .then(({ data: vehicleData }) => {
                if (vehicleData) {
                    const { id, images, price, url, brand, type, enrichedValues } = vehicleData;
                    const productToAdd = {
                        id,
                        vehicle_id: enrichedValues.vehicle_id,
                        image: images[0].path,
                        price,
                        url,
                        title: brand,
                        subtitle: type,
                    };
                    favoriteStore.toggleItem(productToAdd);
                }
            })
            .catch((error) => {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
                throw new Error(error);
            });
    }
});

document.addEventListener('toggle-favorite-dom-element', function (event) {
    const productId = event.detail.productId;

    updateFavoritesButton(productId);
});
